import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { NoticeReportDto } from '@shared/src/dtos/notice/NoticeReportDto';
import { NoticeTenantOptionDto } from '@shared/src/dtos/notice/NoticeTenantOptionDto';
import { NoticeAcknowledgeDto, NoticeViewDto } from '@shared/src/dtos/notice/NoticeViewDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseController } from '../base.controller';

/***
 * Avisos que ha de veure l'usuari i anàlisi de les respostes. El manteniment
 * dels avisos va per NoticeMaintenanceController.
 */
@Injectable({
    providedIn: 'root',
})
export class NoticeController extends BaseController {

    private base = '/notice';

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router);
    }

    public getPending(): Observable<NoticeViewDto[]> {
        return this.get(this.base + '/pending');
    }

    public getRead(): Observable<NoticeViewDto[]> {
        return this.getBusy(this.base + '/read');
    }

    public markSeen(noticeId: number): Observable<boolean> {
        return this.post(this.base + '/' + noticeId + '/seen', {}, 'NoticeController.markSeen');
    }

    public acknowledge(noticeId: number, value: NoticeAcknowledgeDto): Observable<boolean> {
        return this.postBusy(this.base + '/' + noticeId + '/acknowledge', value, 'NoticeController.acknowledge');
    }

    public getReport(noticeId: number): Observable<NoticeReportDto> {
        return this.getBusy(this.base + '/analysis/report/' + noticeId);
    }

    public getTenants(): Observable<NoticeTenantOptionDto[]> {
        return this.getBusy(this.base + '/analysis/tenants');
    }
}
